export default __webpack_public_path__ + "static/media/linkedin.61b4b0c5.png";